// @flow
import * as React from 'react';
import bem from '@justpark/helpers/src/bem/bem';

import '../../../static/scss/components/policies/orderedList.scss';

type Props = {
  children: React.Node,
  roman?: boolean,
  alpha?: boolean,
  number?: boolean,
  margin?: boolean,
  size?: 'small' | 'medium',
  bold?: boolean
};
const baseClass = 'c-ordered-list';

const OrderedList = ({
  children,
  bold = false,
  roman = false,
  alpha = false,
  number = false,
  margin = false,
  size = 'small'
}: Props) => (
  <ol
    className={bem(baseClass, null, {
      roman,
      alpha,
      number,
      margin,
      size,
      bold
    })}
  >
    {children}
  </ol>
);

export default OrderedList;
